import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

function AnnotateCleanupIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M 4.321 9.921 L 15.321 9.921 L 15.321 11.921 L 4.321 11.921 L 4.321 9.921 Z M 4.321 7.921 L 15.321 7.921 L 15.321 5.921 L 4.321 5.921 L 4.321 7.921 Z M 4.321 15.921 L 11.321 15.921 L 11.321 13.921 L 4.321 13.921 L 4.321 15.921 Z M 19.331 12.791 L 20.041 12.081 C 20.431 11.691 21.061 11.691 21.451 12.081 L 22.161 12.791 C 22.551 13.181 22.551 13.811 22.161 14.201 L 21.451 14.911 L 19.331 12.791 Z M 18.621 13.501 L 13.321 18.801 L 13.321 20.921 L 15.441 20.921 L 20.741 15.621 L 18.621 13.501 Z" />
            <path d="M 22.454 3.51 L 21.849 2.921 L 19.446 5.253 L 17.04 2.921 L 16.435 3.51 L 18.839 5.842 L 16.435 8.173 L 17.04 8.761 L 19.446 6.429 L 21.849 8.761 L 22.454 8.173 L 20.051 5.842 L 22.454 3.51 Z" />
        </SvgIcon>
    );
}

export default AnnotateCleanupIcon;